
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","x":".5","y":".5","fill":"#fff","stroke":"#CDCDCD","rx":"1.5"}}),_c('path',{attrs:{"fill":"#4285F4","d":"M13.846 8.624q-.002-.595-.102-1.143h-5.13v2.094l2.954.001a2.52 2.52 0 0 1-1.096 1.687v1.359h1.759c1.027-.946 1.615-2.345 1.615-3.998"}}),_c('path',{attrs:{"fill":"#34A853","d":"M10.473 11.263c-.49.329-1.12.521-1.858.521-1.425 0-2.633-.956-3.066-2.244H3.735v1.401a5.46 5.46 0 0 0 4.88 2.995c1.475 0 2.714-.483 3.616-1.315z"}}),_c('path',{attrs:{"fill":"#FABB05","d":"M5.378 8.5c0-.362.06-.711.17-1.04V6.059H3.736A5.4 5.4 0 0 0 3.154 8.5c0 .879.21 1.708.58 2.442L5.55 9.54a3.3 3.3 0 0 1-.17-1.04"}}),_c('path',{attrs:{"fill":"#E94235","d":"M8.615 5.216c.805 0 1.526.276 2.095.815l1.559-1.55c-.947-.878-2.18-1.417-3.654-1.417a5.46 5.46 0 0 0-4.88 2.995L5.549 7.46c.433-1.288 1.641-2.244 3.066-2.244"}})])
          )
        }
      }
    